import { render, staticRenderFns } from "./sample-make-order.vue?vue&type=template&id=0fa95ceb&scoped=true"
import script from "./sample-make-order.vue?vue&type=script&lang=js"
export * from "./sample-make-order.vue?vue&type=script&lang=js"
import style0 from "./sample-make-order.vue?vue&type=style&index=0&id=0fa95ceb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa95ceb",
  null
  
)

export default component.exports